import { BasicInput } from '@elotech/components';
import React from 'react';

import { TinyMCE, TinyMCEAction } from './TinyMCE';

type BasicInputProps = React.ComponentProps<typeof BasicInput>;
type FormikTinyMCEProps = BasicInputProps & {
  actions?: TinyMCEAction[];
};

export const FormikTinyMCE: React.FC<FormikTinyMCEProps> = ({
  actions,
  ...props
}) => {
  return (
    <BasicInput
      {...props}
      render={({ field }) => (
        <TinyMCE
          editorId={field.id}
          value={field.value}
          onChange={newValue =>
            field.onChange({
              target: {
                name: field.name,
                value: newValue
              }
            } as React.ChangeEvent<any>)
          }
          disabled={field.disabled}
          actions={actions}
        />
      )}
    />
  );
};

export default FormikTinyMCE;
